import { ViewContainerRef } from '@angular/core';
import { UsersListComponent } from 'src/app/pages/companies/components/users-list/users-list.component';

export const loadTable = async ({ table }: { table: ViewContainerRef }): Promise<UsersListComponent> => {
  const { UsersListComponent: users } = await import(
    `src/app/pages/companies/components/users-list/users-list.component`
  );
  table.clear();
  const instance = table.createComponent<UsersListComponent>(users).instance;
  return instance;
};
